import React from 'react';
import SelectVehicle, { ModelYear } from '../../3_Organisms/SelectVehicle/SelectVehicle';
import parse from 'html-react-parser';

interface VehicleVisual {
  static_content_base_path: string;
  jelly_path: string;
  jelly: string;
  interiors: any[];
  exteriors: any;
}

interface VehicleData {
  id: string;
  isEV: boolean;
  title: string;
  model: string;
  msrp: number;
  year: string;
  description: string;
  visual: VehicleVisual;
}

interface SelectVehicleStepProps {
  title?: string;
  handleNextStep: (data: { vehicleData: VehicleData }) => void;
  introductionText?: string;
  preDefinedModelId?: string;
}

const SelectVehicleStep: React.FC<SelectVehicleStepProps> = ({
  title = '',
  handleNextStep,
  introductionText = '',
  preDefinedModelId
}) => {
  const onSelectVehicle = (data: ModelYear) => {
    // API response has more fields than ModelYear interface - use type assertion
    const apiData = data as any;
    const vehicleData: VehicleData = {
      id: apiData.id,
      isEV: apiData.is_ev || false,
      title: apiData.carline.title,
      model: apiData.carline.voi_leads_name || '',
      msrp: apiData.financial.msrp,
      year: apiData.year.url_slug || apiData.year.title,
      description: apiData.description,
      visual: apiData.visual
    };

    handleNextStep({ vehicleData });
  };

  return (
    <div className="mz-select-vehicle-step">
      {introductionText && (
        <div className="mz-select-vehicle-step__intro">
          <div className="mz-container">
            <div className="grid-inner-content-wide paragraph mz-select-vehicle-step__intro-inner">
              {parse(introductionText)}
            </div>
          </div>
        </div>
      )}
      <div className="mz-select-vehicle-step__top">
        <h5 className="mz-select-vehicle-step__title">{title}</h5>
      </div>
      <SelectVehicle onSelectVehicle={onSelectVehicle} preDefinedModelId={preDefinedModelId} />
    </div>
  );
};

export default SelectVehicleStep;
